import { Button } from '@/components';

import { Icons } from '../../common';

type HelperButtonsProps = {
    handleExport: () => void;
    setShowHistory: (show: boolean) => void;
    setShowGuidedTour: (show: boolean) => void;
};

export const HelperButtons = ({
    handleExport,
    setShowHistory,
    setShowGuidedTour,
}: HelperButtonsProps) => {
    return (
        <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={handleExport}>
                <Icons.download className="h-4 w-4 mr-2" />
                Export Results
            </Button>
            <Button variant="outline" onClick={() => setShowHistory(true)}>
                <Icons.history className="h-4 w-4 mr-2" />
                View History
            </Button>
        </div>
    );
};
